module.exports = __webpack_public_path__ + "img/INNOVAK.4b90145f.png";